import { GlobeIcon } from 'lucide-react';

import { useLanguage } from '@/contexts/language-context';
import type { Language } from '@/lib/i18n';

export function LangToggle() {
  const { language, setLanguage } = useLanguage();
  const other: Language = language === 'en' ? 'es' : 'en';

  return (
    <button
      onClick={() => setLanguage(other)}
      className="flex items-center gap-1.5 text-xs font-medium px-2.5 py-1.5 rounded-md border border-border bg-background hover:bg-muted transition-colors"
      title={`Switch to ${other === 'en' ? 'English' : 'Español'}`}
    >
      <GlobeIcon className="w-3.5 h-3.5" />
      {language.toUpperCase()}
    </button>
  );
}
